<template>
    <div class="container">
        <vue-headful title="ABL Groupe | HSEP" />
        <h2>HSEP ( HOESCH SCHWERTER EXTRUDED PROFILES )</h2>
        <section class="society--process">
            <div class="society--content">
                <div class="society--process--picture col-xs-12 col-md-5"><img :src="require('../../../assets/images/Extrudechaud_Hoesch.jpg')"/></div>
                <div class="society--process--description flex-end col-xs-12 col-md-5">
                    <div class="col-xs-12">
                        <h3>Profilés spéciaux en aciers filés à chaud</h3>
                        <div>
                            <h4>Dimensions</h4>
                            <div>
                                Les profilés d’une épaisseur minimum de 4 mm doivent s’inscrire dans un cercle de 240 mm maximum.
                                Des profilés creux peuvent être réalisés avec un diamètre intérieur ou une diagonale de 20 mm minimum à 160 mm maximum.
                            </div>
                        </div>
                        <div>
                            <p>Poids / mètre : de 1,5 à 100 kg.</p>
                        </div>
                        <div>
                            <p>Longueur : de 3 à 16,8 m</p>
                        </div>
                        <h3>Hot extruded steels special profiles</h3>
                        <div>
                            <h4>Sizes :</h4>
                            <div>Profiles must have a minimum thickness of 4 mm and should be designed within a circle of 240 mm maximum.</div>
                        </div>
                        <div>Inner diameter or diagonal for hollow profiles should be at least 20 mm up to 160 mm.</div>
                        <div>
                            <p>Weight / meter : from 1,5 to 100 kg</p>
                        </div>
                        <div>
                            <p>Length : from 3 to 16,8 m</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "HSEPHotextruded"
    }
</script>

<style scoped>

</style>